import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { UpdateDataCycleComponent } from './update-data-cycle/update-data-cycle.component'
import { DataCyclesComponent } from './data-cycles.component'
import { CreateDataCycleComponent } from './create-data-cycle/create-data-cycle.component'
import { contactTitlesRoutes } from './data-cycles.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { SwitchDataCycleComponent } from './switch-data-cycle/switch-data-cycle.component'
import { DataGenerationSectionModule } from '@components/data-generation-section/data-generation-section.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    DataCyclesComponent,
    CreateDataCycleComponent,
    UpdateDataCycleComponent,
    SwitchDataCycleComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(contactTitlesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    DataGenerationSectionModule,
    BreadcrumbsModule,
  ],
  exports: [
    DataCyclesComponent,
    CreateDataCycleComponent,
    UpdateDataCycleComponent,
  ],
})
export class DataCyclesModule {}
